<template>
  <div class="left-menu">
    <b-navbar-nav variant="">
      <b-nav-item-dropdown
        id="service_overview"
        text="Service Overview"
        class="service-over-dropdown"
        menu-class="shadow animated--grow-in minw-12_5r rounded-sm border"
        @show="showServiceOverview"
      >
        <!-- <b-dropdown-item
          to="/guide/intro"
          @click.exact="removeSideBarFocus"
        >
          Introduction of CP Portal
        </b-dropdown-item>

        <b-dropdown-item
          to="/guide/serviceintro"
          @click.exact="removeSideBarFocus"
        >
          Service Introduction
        </b-dropdown-item> -->
        <b-dropdown-item
          to="/guide/usermanual"
          @click.exact="removeSideBarFocus"
        >
          User Manual
        </b-dropdown-item>
        <b-dropdown-item
          to="/guide/dimensionindex"
          @click.exact="removeSideBarFocus"
        >
          Dimension and index
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item
        to="/notices"
        @click="removeSideBarFocus"
      >
        Notice
      </b-nav-item>
    </b-navbar-nav>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      serviceIntroduction: false,
      userManual: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      isLoggedIn: 'isLoggedIn',
      hasAgreed: 'hasAgreed',
      isSysAdmin: 'isSysAdmin',
      userProfile: 'userProfile',
    }),
  },
  methods: {
    showServiceOverview() {
      this.serviceIntroduction = false;
      this.userManual = false;
    },
    ...mapActions('user', {
      setFocusOnSidebar: 'setFocusOnSidebar',
    }),
    removeSideBarFocus() {
      this.setFocusOnSidebar(false);
    },
    alertTBD() {
      alert('To be developed'); // eslint-disable-line no-alert
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables.scss';
.left-menu {
    position: absolute;
    left: 17.5rem !important;
    margin-left: 3rem !important;
}
.topbar .nav-link {
    font-size: 0.9375rem;
    font-weight: 600;
    color: #ffffff !important;
    &:hover {
        background: #2684FF;
    }
}
.service-over-dropdown {
    .dropdown-menu {
        width: 13.5rem !important;
        .dropdown-item {
          &:hover {
           width : 10.3rem !important;
          }
        }
        .rightDropdown{
          margin-left: 0.1rem !important;
          width: 9.5rem !important;
          .dropdown-item {
            &:hover {
              width : 6.3rem !important;
            }
          }
        }
        .userManual{
          margin-left: 0.1rem !important;
          width: 11.7rem !important;
          .dropdown-item {
            &:hover {
              width : 8.5rem !important;
            }
          }
        }
    }
}
.community-dropdown {
    .dropdown-menu {
        width: 7rem !important;
        .dropdown-item {
          &:hover {
           width : 3.82rem !important;
          }
        }
    }
}
.dropdown-menu {
    top: 100% !important;
    .dropdown-item {
        font-size: 0.9375rem;
        font-weight: 600;
        &:hover {
            color: #2684FF;
            background: #E7EFFF;
            padding-left: 1.3rem;
            margin-left: 0.2rem;
        }
        &:hover .arrow-right{
            border: solid #2684FF;
            border-width: 0 0.13rem 0.13rem 0;
            display: inline-block;
            padding: 0.18rem;
        }
    }
}
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu ul{
  display: block;
}
.dropdown-submenu .dropdown-menu {
  top: 0 !important;
  left: 100%;
  margin-top: -1px;
}
.dropdown-submenu a{
    color: #3a3b45;
    font-size: 0.9375rem;
    font-weight: 600;
}
.arrow-right {
  border: solid #3a3b45;
  border-width: 0 0.13rem 0.13rem 0;
  display: inline-block;
  padding: 0.18rem;
}
.right {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: rotate(-45deg) translate(0%,-50%);
  -webkit-transform: rotate(-45deg) translate(0%,-50%);
}
// .right:hover{
//   border: solid #2684FF;
// }
.rightarrow {
  width: 8.8rem !important;
}
</style>
